import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable progress wheel component
 * Displays either a spinner (progress === -2) or a circular progress indicator (progress 0-100)
 */
@Component({
	selector: 'app-progress-wheel',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './progress-wheel.component.html',
	styleUrls: ['./progress-wheel.component.scss'],
})
export class ProgressWheelComponent {
	// Progress value: -2 for spinner, 0-100 for progress wheel
	@Input() progress: number = -2;

	/**
	 * Check if showing a spinner (no specific progress)
	 */
	get isSpinner(): boolean {
		return this.progress === -2;
	}

	/**
	 * Check if showing a progress wheel (specific percentage)
	 */
	get isProgressWheel(): boolean {
		return this.progress >= 0 && this.progress <= 100;
	}

	/**
	 * Calculate stroke-dasharray for circular progress indicator
	 * Based on SVG circle circumference (2 * PI * radius)
	 */
	get strokeDasharray(): string {
		const radius = 16; // SVG inner circle radius
		const circumference = 2 * Math.PI * radius;
		const progressRatio = this.progress / 100;
		const dashLength = circumference * progressRatio;
		return `${dashLength} ${circumference}`;
	}

	/**
	 * Get stroke color - always inherits from parent text color
	 */
	get strokeColor(): string {
		return 'currentColor';
	}

	/**
	 * Get stroke color for background elements (more transparent)
	 * Uses semi-transparent version of current color
	 */
	get strokeColorLight(): string {
		return 'currentColor';
	}

	/**
	 * Get stroke color for outer spinning ring
	 * Uses semi-transparent version of current color
	 */
	get strokeColorSpinner(): string {
		return 'currentColor';
	}
}
